
import { mdiTrashCan } from '@mdi/js'
import { mapGetters, mapActions } from 'vuex'
import { giftWrappingMap } from '@/constants/giftwrapping'
export default {
  head() {
    return {
      title: 'Cart • Pen The Journey',
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return { mdiTrashCan, giftWrappingMap, total: 0 }
  },
  async mounted() {
    try {
      this.getUserCart()
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    ...mapGetters('cart', ['productsInCart', 'cartLength']),
    itemTotal() {
      const { item } = this
      if (!item) return (0).toFixed(2)

      const { coverGraphic, personalizedText, ...newObj } = item
      const v = Object.values(newObj)

      if (!v.length) return (0).toFixed(2)

      const itemTotal = v.reduce((acc, cur) => {
        return acc + (+cur.price) || (+cur.cost)
      }, 0)

      return itemTotal.toFixed(2)
    },
    calculateCartTotal() {
      const { productsInCart: cart } = this

      const total = cart.reduce((acc, cur) => {
        //if(cur.product.name === "Gift Card") return acc + (+cur.product.cost);
        return acc + (+cur.itemTotal)
      }, 0)

      return total

    },
  },
  methods: {
    ...mapActions('cart', ['getUserCart', 'removeProductFromVuexCart']),
  },
}
